import React from 'react';
import classNames from 'classnames';

export type IconContainerProps = {
  variant: 'light' | 'dark' | 'danger' | 'success';
  children?: React.ReactNode;
  className?: string;
};

export const IconContainer = ({
  variant,
  children,
  className,
}: IconContainerProps) => {
  return (
    <div
      className={classNames(
        'inline-block p-3 rounded-full text-2xl',
        {
          'bg-primary-200 text-teal-500': variant === 'light',
          'bg-teal-500 text-white': variant === 'dark',
          'bg-red-200 text-red-800': variant === 'danger',
          'bg-emerald-200 text-emerald-800': variant === 'success',
        },
        className
      )}
    >
      {children}
    </div>
  );
};
